<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Restablecer Constraseña</h4>
                                    <p>Porfavor ingrese su nueva constraseña.</p>
                                </div>

                                <vs-input type="password" label-placeholder="Password" v-model="newPass" class="w-full mb-6" />
                                <vs-input type="password" label-placeholder="Confirm Password" v-model="vNewPass" class="w-full mb-8" />

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <div v-if="newPass == vNewPass">
                                        <vs-button class="w-full sm:w-auto" @click="resetPass">Establecer constraseña</vs-button>
                                    </div>
                                    <div v-else>
                                        <small>Las constraseñas no coinciden.</small>
                                    </div>
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Ir al inicio de sesión</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data () {
    return {
      code: null,
      newPass: null,
      vNewPass: null,
      value2: '',
      value3: ''
    }
  },
  methods: {
      resetPass(){
          firebase.auth().confirmPasswordReset(this.code, this.newPass)
        .then((response) => {
        // Success
            console.log(response);
            window.location.href = '/pages/login';  
        })
        .catch((err) => {
        // Invalid code
            console.log(err);
            this.showAlert('danger','Error','Error estableciendo contraseña. '+err.message);

        })
      },
      showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    }
  },
  beforeMount(){
      console.log(this.$route.query);
      this.code = this.$route.query.oobCode;
  },
  mounted(){

  }
}
</script>
